import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/user-management/password`;

export const passwordRoutesObj = {
  reset: `${baseRoute}/reset/:userId`,
} as const;

export type IPasswordRouteParams = IExtractRouteParamMap<
  typeof passwordRoutesObj
>;

export const passwordPath = createPaths<
  typeof passwordRoutesObj,
  IPasswordRouteParams
>(passwordRoutesObj);
